import { defineSlotRecipe } from '@chakra-ui/react'

export const toastSlotRecipe = defineSlotRecipe({
  slots: ['root'],
  className: 'chakra-toast',
  base: {
    root: {
      '&[data-type=warning]': {
        bg: 'brand.warning',
        color: 'white',
        '--toast-trigger-bg': '{white/10}',
        '--toast-border-color': '{white/40}',
      },
      '&[data-type=success]': {
        bg: 'green.solid',
        color: 'green.contrast',
        '--toast-trigger-bg': '{white/10}',
        '--toast-border-color': '{white/40}',
      },
      '&[data-type=error]': {
        bg: 'red.solid',
        color: 'red.contrast',
        '--toast-trigger-bg': '{white/10}',
        '--toast-border-color': '{white/40}',
      },
    },
  },
})
